import { p as promiseResolve, b as bootstrapLazy } from './index-66dc3685.js';
export { s as setNonce } from './index-66dc3685.js';

/*
 Stencil Client Patch Esm v3.2.1 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
  return promiseResolve();
};
const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
    return bootstrapLazy([["ez-button", [[1, "ez-button", {
      "type": [1],
      "loading": [4],
      "href": [1],
      "disabled": [1540]
    }, [[2, "click", "captureClick"], [0, "keydown", "handleKeyDown"]]]]]], options);
  });
};
export { defineCustomElements };

